import "../../styles/about/aboutBuiltFor.css";

const BUILT_FOR = [
  {
    icon: "🎓",
    title: "Students",
    description:
      "Understand complex topics visually instead of memorizing definitions.",
  },
  {
    icon: "📚",
    title: "Educators",
    description:
      "Explain concepts clearly using reusable, step-by-step visual narratives.",
  },
  {
    icon: "🛠️",
    title: "Builders",
    description:
      "Break down algorithms, systems, and ideas into intuitive visual stories.",
  },
];

const AboutBuiltFor = () => {
  return (
    <section className="about-builtfor">
      <div className="about-builtfor-header">
        <h2>Built for how people actually learn</h2>
        <p>
          VisualLab supports learners and creators who believe understanding
          comes from seeing, not memorizing.
        </p>
      </div>

      <div className="about-builtfor-container">
        {BUILT_FOR.map((item, index) => (
          <div key={index} className="builtfor-card">
            <div className="icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutBuiltFor;
